// extracted by mini-css-extract-plugin
module.exports = {"WithdrawalDaysBox":"WithdrawalDaysBox___22MRF","label":"label___17aU2","value":"value___18BIE"};